import { render } from "./splitbutton.vue?vue&type=template&id=0741af4e"
import script from "./splitbutton.vue?vue&type=script&lang=js"
export * from "./splitbutton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__